import UsersAndTeamsAssetAccessPanelWithDataFetching from 'ui-asset-management-lib/components/UsersAndTeamsAssetAccessPanelWithDataFetching';
import withModalProps from '../../hoc/withModalProps';
import { MODAL_TYPES } from '../../constants/ModalConstants';
import { getContentId, getTeamPerms, getUserPerms } from '../../utils/crmObject';
import { assignPermissions } from '../../api/interactives';
import usageTracker from 'web-interactives-dashboard-ui/utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
// We don't re-fetch the crm objects when permissions are set
const LOCALLY_SET_PERMISSION_CACHE = {};
const getInitiallyAsssignedTeams = objects => {
  var _LOCALLY_SET_PERMISSI, _LOCALLY_SET_PERMISSI2;
  if (objects.length > 1) {
    return [];
  }
  const object = objects[0];
  const contentId = getContentId(object);
  return (_LOCALLY_SET_PERMISSI = (_LOCALLY_SET_PERMISSI2 = LOCALLY_SET_PERMISSION_CACHE[contentId]) === null || _LOCALLY_SET_PERMISSI2 === void 0 ? void 0 : _LOCALLY_SET_PERMISSI2.teams) !== null && _LOCALLY_SET_PERMISSI !== void 0 ? _LOCALLY_SET_PERMISSI : getTeamPerms(object);
};
const getInitiallyAssignedUsers = objects => {
  var _LOCALLY_SET_PERMISSI3, _LOCALLY_SET_PERMISSI4;
  if (objects.length > 1) {
    return [];
  }
  const object = objects[0];
  const contentId = getContentId(object);
  return (_LOCALLY_SET_PERMISSI3 = (_LOCALLY_SET_PERMISSI4 = LOCALLY_SET_PERMISSION_CACHE[contentId]) === null || _LOCALLY_SET_PERMISSI4 === void 0 ? void 0 : _LOCALLY_SET_PERMISSI4.users) !== null && _LOCALLY_SET_PERMISSI3 !== void 0 ? _LOCALLY_SET_PERMISSI3 : getUserPerms(object);
};
const ManageAccessPanelWithProps = ({
  objects,
  onClose
}) => {
  const contentIds = objects.map(getContentId);
  const teamIds = getInitiallyAsssignedTeams(objects);
  const userIds = getInitiallyAssignedUsers(objects);
  return /*#__PURE__*/_jsx(UsersAndTeamsAssetAccessPanelWithDataFetching, {
    assignedTeamIds: teamIds,
    assignedUserIds: userIds,
    onSave: ({
      selectedTeamIds,
      selectedUserIds
    }) => {
      const data = {
        users: selectedUserIds,
        teams: selectedTeamIds
      };
      const trackingProperties = {
        what_value: contentIds,
        action: 'Assign Permissions',
        event: 'assign-permissions'
      };
      assignPermissions(contentIds, data).then(() => {
        for (const contentId of contentIds) {
          LOCALLY_SET_PERMISSION_CACHE[contentId] = data;
        }
        onClose();
        usageTracker.trackDashboardInteraction(Object.assign({}, trackingProperties, {
          succeeded: true
        }));
      }).catch(err => {
        usageTracker.trackDashboardInteraction(Object.assign({}, trackingProperties, {
          succeeded: false
        }));
        console.error(err);
      });
    },
    onCancel: onClose
  });
};
export const ManageAccessPanel = withModalProps(ManageAccessPanelWithProps, MODAL_TYPES.MANAGE_ACCESS);